import anime from 'animejs/lib/anime.es.js';

jQuery( document ).ready(function($) {

  // Detect if element is inview
  var inView = function ( elements ) {

    var $window    = $(window);
    var docViewTop = $window.scrollTop() + $window.height() - ( $window.height() / 10 );

    elements.each( function( index ) {

      if ( !$(this).hasClass('over') ) {

        var elemTop = $(this).offset().top;

        if ( elemTop < docViewTop ) {
          $(this).addClass('over');
        }

      }

    });

  };

  inView( $('.inview') );

  $( window ).scroll( function(e) {
    inView( $('.inview') );
  });

  var circlePath          = 'M438,219A219,219,0,1,1,219,0c65.38,0,118.8,23,156.51,60.46C415.66,100.34,438,156.63,438,219Z';
  var circleDistortedPath = 'M451.2,221.88c0,62-80,74-94,124-14.74,52.63-78,84-136.6,68-60.06-16.4-129.53,16.7-169.4-25-37.59-39.32-32-112.53-48-169-17-60,37.37-99.37,77-139s20-88,142-80c65.24,4.27,140,40,155,88C394.08,142.9,451.2,159.5,451.2,221.88Z';

  circlePath = 'M1.74,143.57c0-117-13-141,32-143s79,4,117,0,64.92,13,96,48,26.75,43.32,26.4,81.16,15,103.84-33.19,100.84-77.17,28-119.17,25-111-6-115-59Z';
  circleDistortedPath = 'M0,177.63c0-117,7.42-105.25,32-143,52-79.88,79,4,117,0s64.91,13,96,48,26.75,43.31,26.39,81.15,15,103.85-33.19,100.85-77.16,28-119.16,25-111-6-115-59Z';
  // ANIME.JS EXAMPLE FUNCTION

//

anime({
    targets: '.circle',
    strokeWidth: {
      value: '4',
      duration: 5000,
      easing: 'easeInElastic(1, .6)'
    },
    strokeWidth: {
      value: '0.5',
      duration: 5000,
      easing: 'easeInElastic(1, .6)'
    },
    stroke: {
      value: '#000000',
      duration: 1000,
      easing: 'easeInElastic(1, .6)'
    },
    stroke: {
      value: '#ff0000',
      duration: 5000,
      easing: 'easeInElastic(1, .6)'
    },
    strokeDashoffset: {
      value: '1 1',
      duration: 5000,
      easing: 'easeInElastic(1, .6)'
    },
    strokeDashoffset: {
      value: '5 20',
      duration: 5000,
      easing: 'easeInElastic(1, .6)'
    },
    autoplay: true,
    direction: 'alternate',
    loop: true
  });

var animate = anime({
  targets: '.shape',
  d: [
    { value: "m212.5,161.98333c0,0 152,-184 256,-68c104,116 113,251.03334 89.5,284.01667c-23.5,32.98333 -176.5,163.98333 -269.5,109.98333c-93,-54 -123,-88.96666 -133.5,-126.98333c-10.5,-38.01667 5.5,-126.01667 57.5,-199.01667z"}
  ],
  autoplay: true,
  direction: 'alternate',
  duration: 5000,
  easing: 'easeOutQuad',
  //transformOrigin: "0 0 0",
  //easing: 'easeInOutElastic(1, .5)',
  loop: true
});

  // anime({
  //   targets: '.banner',
  //   translateX: 250,
  //   rotate: '1turn',
  //   backgroundColor: '#FFF',
  //   duration: 800
  // });

});
